// YERİ: src/app/domains/website/core/site-texts.store.ts
//
// VİTRİNİN SAYFA-DIŞI METİNLERİ — 404 sayfası, blog başlığı, site geneli
// yapısal verideki (JSON-LD) tanıtım cümleleri.
//
// Bu metinler bir CMS SAYFASINA ait değil (404 ve blog, CMS sayfası olmadan
// çizilir), o yüzden bir dönem kodda İngilizce sabitti: Türkçe vitrinde de
// "Page not found" yazıyordu ve panelden değiştirilemiyordu. Artık Ana Şablon'un
// (dil başına) "Site Metinleri" bölümünden (mkt-site-texts) geliyor; web-layout
// çerçeveyi kurarken bu bölümün config'ini buraya yazar.
//
// Alan boşsa bugünkü İngilizce metin kullanılır — bölüm hiç eklenmemiş ya da
// doldurulmamış bir dilde site olduğu gibi kalır.

import { Injectable, signal } from '@angular/core';
import { SiteConfig, cfg } from '@/app/domains/site/sections/section.model';

export const SITE_TEXT_DEFAULTS = {
  notFoundTitle: 'Page not found',
  notFoundText: 'The page you are looking for doesn’t exist or has moved.',
  notFoundCta: 'Back to home',
  blogTitle: 'Blog',
  blogSubtitle: 'Product news, playbooks and industry deep dives.',
  blogSeoDescription: 'Product news, playbooks and industry deep dives from Melbarrel.',
  blogEmpty: 'No posts yet.',
  blogBack: 'Blog',
  orgDescription:
    'Business management software for service businesses: CRM, bookings, staff, '
    + 'invoicing and a website builder in one system.',
  appDescription:
    'Melbarrel combines customer records, scheduling, staff management, quoting, '
    + 'invoicing, online payments and a website builder into one platform, with 30 '
    + 'industry-specific modules.',
} as const;

export type SiteTextKey = keyof typeof SITE_TEXT_DEFAULTS;

/** Ana Şablon'daki bölüm tipi. */
export const SITE_TEXTS_BLOCK = 'mkt-site-texts';

@Injectable({ providedIn: 'root' })
export class MktSiteTexts {
  /** Aktif dilin "Site Metinleri" bölümünün config'i (yoksa boş). */
  readonly config = signal<SiteConfig>({});

  text(key: SiteTextKey): string {
    return cfg(this.config(), key, SITE_TEXT_DEFAULTS[key] as string);
  }
}
